// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles co-localises de l'onglet Historique operation-MS (V2).
   .section-header / .section-content viennent du global App.css (toujours charges).
   .empty-state est repris ici a l'identique de SuiviOperation/SuiviOperation.css,
   non importe par la vue V2, pour preserver l'apparence de l'etat vide. */

.tab-suivi-marche {
  display: flex;
  flex-direction: column;
}

.tab-suivi-marche .empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.6rem;
  color: #6b7280;
  background-color: #f9fafb;
  border-radius: 0.8rem;
  padding: 2rem;
  margin: 2rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationMSV2/components/OperationHistoriqueMarche.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB","sourcesContent":["/* Styles co-localises de l'onglet Historique operation-MS (V2).\n   .section-header / .section-content viennent du global App.css (toujours charges).\n   .empty-state est repris ici a l'identique de SuiviOperation/SuiviOperation.css,\n   non importe par la vue V2, pour preserver l'apparence de l'etat vide. */\n\n.tab-suivi-marche {\n  display: flex;\n  flex-direction: column;\n}\n\n.tab-suivi-marche .empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 1.6rem;\n  color: #6b7280;\n  background-color: #f9fafb;\n  border-radius: 0.8rem;\n  padding: 2rem;\n  margin: 2rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
